import { ContactType } from "../dto/Contractors/ContractorDto";

import i18n from "../i18n";
import exhaustiveCheck from "./exhaustiveCheck";

export default (type: ContactType) => {
  switch (type) {
    case "PHONE":
      return i18n.t("phone_number");
    case "EMAIL":
      return "Email";
    case "OTHER":
      return i18n.t("other");
    default:
      return exhaustiveCheck(type);
  }
};
